var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { Box } from "theme-ui";
/**
 * Draws a vertical grey line
 */
export const VerticalDivider = (_a) => {
    var { sx = {}, margin = 0 } = _a, props = __rest(_a, ["sx", "margin"]);
    return (_jsx(Box, Object.assign({ sx: Object.assign({ width: 1, height: "100%", backgroundColor: "grey.3", marginX: margin || 0 }, (sx || {})) }, props)));
};
//# sourceMappingURL=VerticalDivider.js.map